import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/controls/i18n/scope";
declare var $: any;

@Component({
    selector: "browse-files-button",
    templateUrl: "./browse-files-button.component.html",
    styleUrls: ["./browse-files-button.component.scss"],
    imports: [TranslatePipe],
    viewProviders: [provideTranslationScope(scope)]
})
export class EffBrowseFilesButtonComponent {
    @Input() text: string;
    @Input() allowedFileExtensions: string;
    @Input() dataUiid: string = "undefined";
    @Output() onFilesDropped: EventEmitter<File[]> = new EventEmitter();

    @ViewChild("fileInput", { static: true }) fileInput: ElementRef;

    openFileSelect() {
        $(this.fileInput.nativeElement).trigger("click");
    }

    updateFiles() {
        this.onFilesDropped.emit(this.fileInput.nativeElement.files);
    }
}
